import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useState} from "react";
import {cmpClassName, execFn} from "../../../common/generic-react.functions.js";
import {useEventListener} from "../../../hooks/event-listener.hook.js";
import Icon from "../icon/icon.component.js";
import Title from "../title/title.component.js";
import {ModalActionsContainer, ModalCloseContainer, ModalContentContainer, ModalHeaderContainer, ReactModalContainer} from "./modal.styles.js";
function MainModal({
  children,
  show = false,
  contentLabel,
  parent = document.body,
  persistent = false,
  dismiss = true,
  width = "50%",
  height = "100%",
  actions,
  header,
  modalClassName,
  onClose
}, ref) {
  const [isOpen, setIsOpen] = useState(show);
  const [overlayRef, setOverlayRef] = useState(null);
  useEffect(() => {
    setIsOpen(show);
  }, [show]);
  useImperativeHandle(ref, () => {
    return {
      el: null,
      show: () => setIsOpen(true),
      hide: () => setIsOpen(false),
      toggle: () => setIsOpen((state) => !state)
    };
  }, []);
  useEventListener("click", ({
    target
  }) => {
    if (!persistent && isOpen && overlayRef?.isEqualNode && overlayRef.isEqualNode(target)) {
      setIsOpen(false);
    }
  });
  useEventListener("keyup", ({
    code
  }) => {
    if (!persistent && isOpen && code === "Escape") {
      setIsOpen(false);
    }
  });
  const closeX = useMemo(() => dismiss && /* @__PURE__ */ React.createElement(ModalCloseContainer, {
    "aria-hidden": true
  }, /* @__PURE__ */ React.createElement(Icon, {
    name: "times",
    onClick: () => setIsOpen(false)
  })), [dismiss]);
  const Header = useMemo(() => header && /* @__PURE__ */ React.createElement(ModalHeaderContainer, null, typeof header === "string" ? /* @__PURE__ */ React.createElement(Title, null, header) : header), [header]);
  return /* @__PURE__ */ React.createElement(ReactModalContainer, {
    className: cmpClassName("dialog") + " ReactModalContainer",
    isOpen,
    contentLabel,
    shouldFocusAfterRender: false,
    shouldReturnFocusAfterClose: true,
    role: "dialog",
    ariaHideApp: false,
    portalClassName: `ReactModalPortal ${modalClassName || ""}`,
    shouldCloseOnEsc: false,
    shouldCloseOnOverlayClick: false,
    overlayRef: (refNode) => setOverlayRef(refNode),
    parentSelector: () => parent ?? document.body,
    style: {
      overlay: {
        background: "rgba(0, 0, 0, 0.6)",
        paddingTop: "2rem",
        paddingBottom: "2rem"
      }
    },
    onAfterClose: () => execFn(onClose),
    width,
    height
  }, closeX, Header, /* @__PURE__ */ React.createElement(ModalContentContainer, {
    className: "ModalContentContainer"
  }, children), actions && /* @__PURE__ */ React.createElement(ModalActionsContainer, {
    className: "ModalActionsContainer"
  }, actions));
}
const Modal = /* @__PURE__ */ React.memo(/* @__PURE__ */ forwardRef(MainModal));
Modal.displayName = "Modal";
export default Modal;
